import { Component, OnInit, Input} from '@angular/core';
import { CommonService } from '../service/common.service';
import { EventService } from '../service/event.service';
import { UsersService } from '../service/users.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({ 
    selector: 'abr-system-app',
    templateUrl: './abr-system.component.html',
    styleUrls: ['abr-system.component.css']
})
export class AbrSystemComponent implements OnInit {
    title : string = 'システム設定';
    isLoaded : boolean = false;
    datalist : any = [];

    constructor(
        private commonService: CommonService,
        private eventService: EventService,
        public usersService: UsersService,
        private router: Router,
        private route: ActivatedRoute,
        private location: Location,
    ) { }
    ngOnInit(): void {
        this.getList(4);
    };
    clearData (): void{
        this.isLoaded = false;
        this.datalist = [];
    }
    getList(mode:Number): void {
        this.clearData();
        let param ={
            publish_mode:mode,
            page:0,
            display_per_page:0
        };
        this.eventService.getEvent(param)
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                this.datalist= res["fuel_results"]['event'];
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        },error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }
    calc(cont:any) :number{
        var bo=0;
        var ko=0;
        for (let i = 0; i < cont.length; i++) {
            bo = bo + cont[i].count_all*1;
            ko = ko + cont[i].count_done*1;
        }
        if (bo==0){
            return 0;
        }else{
            return ko/bo*100;
        }
    }
    reload(){
        this.getList(4);
    }
}



// WEBPACK FOOTER //
// ./src/app/c9900-abr-system/abr-system.component.ts